import {
  Button,
  Center,
  Flex,
  Image,
  Spacer,
  IconButton,
  Badge,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { HiMenu } from "react-icons/hi";
import { FiBell } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_notifications } from "../redux/NotificationSlice";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasFetchedInitially = useRef(false);

  // Get notifications state from Redux
  const { total_unseen } = useSelector((state) => state.notifications);

  // Fetch notifications only once on mount
  useEffect(() => {
    if (!hasFetchedInitially.current) {
      dispatch(get_notifications());
      hasFetchedInitially.current = true;
    }
  }, [dispatch]);

  // Poll for new notifications every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(get_notifications());
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [dispatch]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  };

  return (
    <Flex h="full" w="full" align="center" p={2}>
      {/* Logo */}
      <Center w="13rem" minW="13rem" display={["none", "none", "none", "flex"]}>
        <Image
          src="logoname.png"
          h="30px"
          w="70%"
          alt="LOGO"
          objectFit="contain"
        />
      </Center>

      <Spacer />

      {/* Notification Bell */}
      <Box position="relative" mr={4} cursor="pointer">
        <IconButton
          icon={<FiBell size={22} />}
          variant="ghost"
          aria-label="Notifications"
          onClick={() => navigate("/notifications")}
        />
        {total_unseen > 0 && (
          <Badge
            colorScheme="green"
            borderRadius="full"
            position="absolute"
            top="0"
            right="0"
            fontSize="0.7em"
            px={1.5}
          >
            {total_unseen}
          </Badge>
        )}
      </Box>

      {/* Logout desktop */}
      <Flex align="" pr={10} display={["none", "none", "none", "flex"]}>
        <Button variant="link" onClick={handleLogout}>
          Log Out
        </Button>
      </Flex>

      {/* Logout mobile */}
      <Flex align="center" pr={2} display={["flex", "flex", "flex", "none"]}>
        <Button variant="link" onClick={handleLogout}>
          Log Out
        </Button>
      </Flex>
    </Flex>
  );
};

export default Header;